import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-file",
  "use": "fileType-file-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"fileType-file\"><defs><symbol id=\"fileType-file_a\" data-name=\"file-unknow\" viewBox=\"0 0 20 20\"><path d=\"M15.77 0H0v20h20V4.23zM12 13.16H5.68v-1.05H12zm2.11-2.53H5.68V9.58h8.42zm0-2.53H5.68V7.05h8.42zm1.67-3.74V.28l4.08 4.08z\" fill=\"#ff9200\" /></symbol></defs><title>fileType-file</title><g data-name=\"图层 2\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-file_a\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-file.svg
// module id = HwBL
// module chunks = 6